import { createFileRoute } from '@tanstack/react-router'
import SamlLogin from '../../../containers/authentication/components/saml-login'

export const Route = createFileRoute('/_unauthenticated/samlLogin/')({
  component: SamlLogin
})
